export const mergeArrays = <T>(
  a: T[],
  b: T[],
  predicate = (item1: T, item2: T) => item1 === item2,
) => {
  const c = [...a]; // copy to avoid side effects
  // add all items from B to copy C if they're not already present
  for (const bItem of b) {
    if (c.some((cItem) => predicate(bItem, cItem))) continue;
    c.push(bItem);
  }
  return c;
};
